import { createContext } from "react";

const landingContext = createContext();

export default landingContext;